


































import assignmentActions from '@adobe/edex/frontend/views/externalCourse/manage/externalCourse-manage-actions.vue';
import { awardBadgeForAssignment } from '@adobe/edex/frontend/api/externalAssignment';
import Vue from 'vue';

export default {
  name: 'assignmentData-row',
  components: { assignmentActions },
  props: {
    index: {
      type: Number,
    },
    assignmentData: {
      default: () => {
        return {};
      },
      type: Object,
    },
    selected: {
      default: () => {
        return new Set();
      },
      type: Set,
    },
  },
  data() {
    return {
      isSelected: this.selected.has(this.assignmentData.assignment_id),
      toggleLoading: false,
    };
  },
  watch: {
    selected(value) {
      if (value.has(this.assignmentData.assignment_id)) {
        this.isSelected = true;
      } else {
        this.isSelected = false;
      }
    },
  },
  computed: {
    lastActivity() {
      return this.assignmentData.last_activity && this.lzDateFmt(this.assignmentData.last_activity);
    },
    getStudentName() {
      const fullName = this.assignmentData.user_details.first_name + ' ' + this.assignmentData.user_details.last_name;
      return fullName.length < 30 ? fullName : this.assignmentData.user_details.first_name;
    },
    getStudentEmail() {
      return this.assignmentData.user_details.email;
    },
    started() {
      return this.assignmentData.started && this.lzDateFmt(this.assignmentData.started);
    },
    assignmentFileURL() {
      return this.assignmentData.file_url;
    },
    assignmentFileName() {
      return this.assignmentData.file_name;
    },
    showAwardButton() {
      //[CCEDU-12072]: Removed "this.assignmentData.steps_completed" condition, will add it later once steps_complete flow added again,TODO[CCEDU-12108]
      return  this.assignmentData.status === 'passed' && !this.assignmentData.awarded;
    },
    disableActionButton() {
      return this.assignmentData.status !== 'pending-review';
    },
    getAssignmentFileName() {
      const fileName = this.assignmentFileName?.replace(/\s\s+/g, ' ');
      return fileName?.slice(-30);
    },
  },
  methods: {
    select() {
      if (this.isSelected) {
        this.$emit('unselected', this.assignmentData.assignment_id);
      } else {
        this.$emit('selected', this.assignmentData.assignment_id);
      }
    },
    async onClickAwarded() {
      const { assignment_id } = this.assignmentData;
      this.loading = true;
      try {
        const { data } = await awardBadgeForAssignment(assignment_id);
        if (data) {
          this.$emit('onRowUpdated', {...this.assignmentData, awarded: data.awarded});
          this.error = false;
        }
      } catch (error) {
        if (error?.response?.data?.details?.error?.code === 'ALREADY_AWARDED') {
          Vue.toasted.info('Already awarded!');
           this.$emit('onRowUpdated', {...this.assignmentData, awarded: true});
         } else {
          this.$emit('onRowUpdatedError');
          this.error = true;
        }
      }
      this.loading = false;
    }
  },
};
